"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStatus = void 0;
var MatchStatus;
(function (MatchStatus) {
    /**
     * Newly created match without any join requests and invites
     */
    MatchStatus["Created"] = "created";
    /**
     * Waiting on invited or joined player but no one approved/rejected
     */
    MatchStatus["Pending"] = "pending";
    /**
     * Has accepted invite or join request and game successfully setup
     */
    MatchStatus["Live"] = "live";
    /**
     * Has accepted invite or join request and game successfully setup, join to the game client is required
     */
    MatchStatus["Lobby"] = "lobby";
    /**
     * Did not receive any player results within 24 hours after the match started
     * OR
     * match didn’t started within 48 hours after creation
     */
    MatchStatus["Expired"] = "expired";
    /**
     * Invited player declined an invitation in private match
     */
    MatchStatus["Declined"] = "declined";
    /**
     * Match creator withdraw the match before the other player accepts it
     */
    MatchStatus["Canceled"] = "canceled";
    /**
     * All players played (system received all scores) or one of them forfeit the match
     */
    MatchStatus["Finished"] = "finished";
    /**
     * Match not started by technical problems (incorrect game setup, etc.)
     */
    MatchStatus["Aborted"] = "aborted";
})(MatchStatus = exports.MatchStatus || (exports.MatchStatus = {}));
//# sourceMappingURL=match-status.js.map